import { ChatMessage } from "../entities/getMessages";
import { ChatMessageParams } from "../entities/getMessagesParams";
import { ChatRepository } from "../repositories/ChatRepository";

export class GetMessages {
	constructor(private repository: ChatRepository) {}
	execute(params: GetMessagesParams): Promise<ChatMessage[]> {
		return this.repository.getMessages(params.data);
	}
}

export class GetMessagesParams {
	constructor(public data: ChatMessageParams) {}
}
